import React from 'react'
import { NextSeo } from 'next-seo';
import HeroHeader from '../components/HeroHeader';
import SimilarCats from '../components/SimilarCats';
import { useDispatch, useSelector } from 'react-redux';
import { wrapper } from '../store/configStore';
import { SERVER_IP } from '../store/middleware/api';
import ClientReviews from '../components/ClientReviews';
import LandingCategories from '../components/LandingCategories';
import PastEvents from '../components/PastEvents';
import { getFilteredProducts, productsSetFilters } from '../store/slices/entities/products';
import landing from '../public/Pictures/fog_machine_h.jpg'
import { compactPublicEvents } from '../utilities/eventPublicPayload';
import { requestPageData } from '../utilities/boundedPageData';



export const getStaticProps = wrapper.getStaticProps(
    async ({ store }) => {
        const [landingResponse, subCategoryResponse] = await Promise.all([
            requestPageData({
              url: `${SERVER_IP}/user/static-landing`,
              fallback: {
                newsletterevents: [],
                total_events: null
              },
              label: 'landing proof for /special-effects'
            }),
            requestPageData({
              url: `${SERVER_IP}/subcategory/name/fog-machine`,
              params: {
                cat: 'special-effects'
              },
              fallback: {
                similar_categories: []
              },
              label: 'related categories for /special-effects'
            })
        ])
        store.dispatch({ type: productsSetFilters.type, payload: { static: true } }) 

        const { newsletterevents = [], total_events = null } = landingResponse.data || {}
        const usedFallback = landingResponse.usedFallback || subCategoryResponse.usedFallback

        return {
            props: {
                newsletterevents: compactPublicEvents(newsletterevents),
                total_events,
                subCate: subCategoryResponse.data
            },
            revalidate: usedFallback ? 60 : 3600
        }
    }
);

const TVRental = ({ newsletterevents, total_events, subCate}) => {
    let products = useSelector(getFilteredProducts)

    return <>
        <NextSeo
          noindex
            title='Special Effects Rentals in Miami, Fort Lauderdale & Palm Beach'
            description='Rent Special Effects Equipment for your event from Miami Sound Rental. Everything is available 24/7 for pick up or delivery.'
            canonical="https://miamisoundrental.com/special-effects"
            twitter={{
                handle: '@miamisoundrent1',
                site: '@miamisoundrent1',
                cardType: 'summary_large_image',
            }}
            openGraph={{
                type: 'website',
                url: `https://miamisoundrental.com/special-effects`,
                title: 'Special Effects Rentals in Miami, Fort Lauderdale & Palm Beach',
                description: 'Rent Special Effects Equipment for your event from Miami Sound Rental. Everything is available 24/7 for pick up or delivery.',
                images: [
                    {
                        url: 'https://dnw-server.s3.us-east-2.amazonaws.com/cold_sparks_og.jpg',
                        width: 800,
                        height: 600,
                        alt: 'Miami Sound Rental',
                    },

                ],
                site_name: 'Miami Sound Rental',
            }}
        />
        <div className='categoryRental projectorRental'>
            <HeroHeader picture={landing}
                title={'Special Effects Rentals'}
                par={``}
                buttons
            />
         
       
       
   
    
            <SimilarCats ui='v2' priority className='noM' subCate={subCate} heading='Special Effects Categories' />
                <LandingCategories ui='v2' title options category='special_effects' />
     
            <PastEvents ui='v2' newsletterevents={newsletterevents} total_events={total_events} />
            <ClientReviews ui='v2' />
        </div>
    </>
}

export default TVRental
